import React from 'react';

const PageLayout = ({ children, className = "container mx-auto px-4 py-6" }) => {
  return (
    <main className={className}>
      {children}
    </main>
  );
};

export default PageLayout;
